import type { MarchOwnGtmEvent } from './types'

export function pushMarchOwnGtmEvent(event: MarchOwnGtmEvent): void {
  try {
    window.marchDataLayer = window.marchDataLayer || []
    window.marchDataLayer.push(event)
  } catch {
    // GTM error should not block the main application flow
  }
}
